import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import httpClient from 'services/httpClient';
import IGetAllCategoryResponse from 'services/httpClient/responses/category/IGetAllCategoryResponse';

import { categoryActions } from '..';

function* getAllToSelect() {
  try {
    const response: AxiosResponse<IGetAllCategoryResponse> = yield call(
      httpClient.get,
      'admins/categories',
    );
    yield put(
      categoryActions.getAllToSelectSuccess({
        list: response.data.list,
        totalPages: response.data.totalPages,
      }),
    );
  } catch (err) {
    yield put(categoryActions.getAllToSelectFailure());
  }
}

export default getAllToSelect;
